import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { GameMenuItems } from '../containers'

const styles = {
}

class GameMenu extends React.Component {
  state = {
    anchorEl: null,
  }

  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { user } = this.props
    const { anchorEl } = this.state
    return (
      <div>
        <IconButton onClick={this.handleOpen} color='inherit'>
          <MoreVertIcon/>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <GameMenuItems user={user} onClose={this.handleClose}/>
        </Menu>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(GameMenu)


// WEBPACK FOOTER //
// ./src/Pages/Game/components/GameMenu.js